module.exports = __webpack_public_path__ + "static/img/AboutImgThree.7c59976.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/AboutImgThree.png
// module id = ytxZ
// module chunks = 1